import { useQuery } from '@tanstack/react-query';

import useMailboxService from 'src/modules/mailer/hooks/useMailboxService';
import useMailerDriver from 'src/modules/mailer/hooks/useMailerDriver';
import {
    getMailboxIntentItems,
    mailboxHasIntents,
    normalizeMailboxIntents,
} from '../helpers';

export const MAILBOX_INTENTS_QUERY_KEY = 'mailbox-fetch-intents';

const withZeroCounts = () => getMailboxIntentItems().map((item) => ({
    ...item,
    count: 0,
}));

const useMailboxIntentsQuery = ({
    enabled = true,
} = {}) => {
    const service = useMailboxService();
    const { active } = useMailerDriver();
    const hasIntents = mailboxHasIntents();
    const query = useQuery({
        queryKey: [MAILBOX_INTENTS_QUERY_KEY, active],
        queryFn: async () => {
            try {
                const payload = await service.fetchIntents();

                return normalizeMailboxIntents(payload);
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.error(error);
                }

                return withZeroCounts();
            }
        },
        enabled: enabled && hasIntents,
        refetchOnWindowFocus: false,
    });

    if (!hasIntents) {
        return [];
    }

    return query.data || withZeroCounts();
};

export default useMailboxIntentsQuery;
